import React, { Component } from "react";
import { Modal, ModalBody } from "reactstrap";
import Card from "../components/Card";
import { getBrowserLocale, orderNodes } from "../Utils/SupportUtils";

class SupportModal extends Component {
  state = {
    nodes: [],
    selectedLeafNode: null,
    historyNodes: [],
  };

  componentDidUpdate(prevProps) {
    const { firstNodeSelected, allNodes } = this.props;
    if (
      this.props.allNodes &&
      !prevProps.firstNodeSelected &&
      firstNodeSelected
    ) {
      const filteredNodes =
        firstNodeSelected &&
        allNodes
          .filter((node) => node.parentnodeid === firstNodeSelected.nodeid)
          .sort(orderNodes);

      const updatedHistoryNodes = [this.props.firstNodeSelected];

      this.setState({
        ...this.state,
        nodes: filteredNodes,
        historyNodes: updatedHistoryNodes,
      });
    }
  }

  fetchChildren = (selected) => {
    const { toggle, allNodes } = this.props;
    const updatedHistoryNodes = [...this.state.historyNodes, selected];
    const filteredNodes = allNodes
      .filter((node) => {
        return node.parentnodeid === selected.nodeid;
      })
      .sort(orderNodes);

    this.setState({
      ...this.state,
      nodes: filteredNodes,
      selectedLeafNode: selected,
      historyNodes: updatedHistoryNodes,
    });
    if (filteredNodes.length === 0) {
      toggle(selected, true, updatedHistoryNodes);
    }
  };

  removeSelection = (index) => {
    const { toggle } = this.props;
    if (index === 0) {
      toggle();
    } else {
      const el = this.state.historyNodes[index - 1];
      const updatedHistoryNodes = this.state.historyNodes.slice(0, index - 1);
      this.setState(
        {
          ...this.state,
          historyNodes: updatedHistoryNodes,
        },
        () => {
          this.fetchChildren(el);
        }
      );
    }
  };

  render() {
    const {
      isOpen,
      styleElements: { iconStyle, bodyStyle },
    } = this.props;

    const language = getBrowserLocale();

    return (
      <Modal
        isOpen={isOpen}
        size="lg"
        backdrop="static"
        style={{
          marginTop: "200px",
        }}
      >
        <ModalBody  style={{padding: "2rem"}}>
          <div className="container pb-2">
            <div className="row justify-content-center">
              {this.state.historyNodes.map((historyNode, index) => {
                return (
                  <div
                    key={index}
                    className="col-auto py-2"
                    style={{ maxWidth: "300px" }}
                  >
                    <div
                      className="card"
                      style={{
                        backgroundColor: iconStyle
                          ? iconStyle.color
                          : "initial",
                      }}
                    >
                      <span
                        style={{
                          padding: "5px",
                          paddingRight: "27px",
                        }}
                      >
                        <span
                          key={historyNode.nodeid}
                          className="text-truncate d-block px-2 rounded"
                          style={{
                            color: "white",
                          }}
                        >
                          <b>
                            {!historyNode.parentnodeid && (
                              <i className={`${historyNode.imgname} m-1`}></i>
                            )}
                            {historyNode.label[language]}
                          </b>
                        </span>
                        <i
                          className="fas fa-times fa-lg ml-2 mr-1"
                          style={{
                            cursor: "pointer",
                            position: "absolute",
                            color: "white",
                            top: "10px",
                            right: "5px",
                          }}
                          onClick={() => this.removeSelection(index)}
                        ></i>
                      </span>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="container" style={{ maxWidth: "900px" }}>
            <div className="row">
              {this.state.nodes.map((node) => {
                return (
                  <div key={node.nodeid} className="col-md-6 my-2">
                    <Card
                      key={node.nodeid}
                      node={node}
                      iconStyle={iconStyle}
                      bodyStyle={bodyStyle}
                      selectHandler={this.fetchChildren}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </ModalBody>
      </Modal>
    );
  }
}

export default SupportModal;
